/* eslint-disable no-useless-constructor */
import { Record } from 'immutable'
import { ACTIVITY_DEFAULT_RATING, ACTIVITY_DEFAULT_IMAGE_DOMAIN_WITH_ID } from 'app/constants/activity'
import { IActivity } from 'store/entities/activity/interface'

export const CATEGORY_TAG_DEFAULT = { name: null, id: null }
/**
 *
 * @type {*|Immutable.Record.Class}
 */
export const ActivityRecord = Record<IActivity>({
  id: null,
  day: null,
  name: null,
  image: null,
  videoId: null,
  videoThumbnail: null,
  description: null,
  proQuote: null,
  proQuoteAuthor: null,
  isValid: true,
  rating: ACTIVITY_DEFAULT_RATING,
  isFavorite: null,
  isRated: null,
  isFinished: null,
  actionType: null,
  deleting: false,
  pinned: false,
  invalid: false,
  example: false,
  level: null,
  fromFile: false,
  previousActionType: null,
  createdAt: null,
  proTrackLevelId: null,
  isRepeating: false,
  question: null,
  userActivityId: null,
  hasStory: false,
  imageDomainWithId: ACTIVITY_DEFAULT_IMAGE_DOMAIN_WITH_ID,
  isImageLinkInvalid: false,
  categoryTag: CATEGORY_TAG_DEFAULT,
  categoryTagId: null,
})

export class Activity extends ActivityRecord {
  constructor(props?: any) {
    super(props)
  }
}
